// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"DeviceInfo_style_b-icon-warning__uiVV0","wrapper":"DeviceInfo_style_wrapper__AbMod","rotate":"DeviceInfo_style_rotate__1bs8Z"};